import styled from 'styled-components';
import { Colors } from 'styles/Constants';

export const PeriodSelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const PeriodCaption = styled.span`
  color: ${Colors.inactive};
  font-size: 12px;
  padding: 0 10px 10px;
`;
